import { motion } from 'framer-motion'
import { JoinCtaButton } from '../components/JoinCtaButton'
import { fadeUp } from '../lib/motion'
import { useT } from '../i18n/t'

const dolnySlaskLogo = '/Dolny_slask.png'

/**
 * Sekcja pod hero: po lewej duży lid „Pierwszy wirtualny turystyczny paszport
 * na Dolnym Śląsku", po prawej herb i logo „DOLNY ŚLĄSK".
 *
 * Górny padding sekcji pod hero.
 */
export function LandingIntroSection() {
  const { t } = useT()

  return (
    <section
      aria-labelledby="landing-intro-heading"
      className="relative overflow-hidden bg-paper"
    >
      <motion.div
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.2 }}
        variants={{ visible: { transition: { staggerChildren: 0.08 } } }}
        className="container-x pt-12 pb-16 md:pt-16 md:pb-24"
      >
        <div className="content grid grid-cols-1 items-center gap-10 md:grid-cols-[1.2fr_0.9fr] md:gap-14">
          <div>
            <motion.p
              variants={fadeUp}
              className="text-[11px] font-extrabold uppercase tracking-[0.18em] text-ink/55"
            >
              {t('landing.intro.eyebrow')}
            </motion.p>

            <motion.h2
              id="landing-intro-heading"
              variants={fadeUp}
              className="display mt-4 max-w-[22ch] text-[28px] font-normal leading-[1.12] text-ink md:text-[40px] md:leading-[1.08] lg:text-[46px]"
            >
              {t('landing.intro.title')}
            </motion.h2>

            <motion.div variants={fadeUp} className="mt-6">
              <JoinCtaButton size="lg">{t('landing.section01.cta')}</JoinCtaButton>
            </motion.div>
          </div>

          <motion.div
            variants={fadeUp}
            className="flex items-center justify-center md:justify-end"
          >
            <img
              src={dolnySlaskLogo}
              alt={t('landing.intro.regionLogoAlt')}
              draggable={false}
              loading="lazy"
              decoding="async"
              className="h-auto w-full max-w-[260px] select-none object-contain md:max-w-[340px] lg:max-w-[380px]"
            />
          </motion.div>
        </div>
      </motion.div>
    </section>
  )
}
